import { AttributeValue } from '@spa/components/product-specifications/AttributeTypes';

const formatAttributeValue = (value: AttributeValue): string => {
  let formattedValue: string = '';
  if ('intValue' in value) {
    formattedValue = `${value.intValue} ${value.unit.toLowerCase()}`;
  } else if ('floatValue' in value) {
    formattedValue = `${value.floatValue} ${value.unit.toLowerCase()}`;
  } else if ('booleanValue' in value) {
    formattedValue = value.booleanValue ? '✔' : '';
  } else if ('stringValue' in value) {
    formattedValue = value.stringValue + (value.optionalUnit ? ` ${value.optionalUnit}` : '');
  }
  return formattedValue;
};

export default formatAttributeValue;
